module.exports = __webpack_public_path__ + "static/media/Yoti.be468c01.png";